import { Link } from "react-router-dom";
import { Ticket } from "lucide-react";
import { useSite } from "@/lib/content";
import { bookingVisible } from "@/lib/booking";
import { t } from "@/lib/i18n";
import { path } from "@/lib/routes";
import { Pending } from "@/components/Pending";

export default function TicketCta({ testId = "ticket-cta", className = "" }) {
  const { site, content, isPreview } = useSite();
  const live = bookingVisible(site, content, false);
  if (!live && !isPreview) return null;
  return (
    <section className={`safe-x max-w-7xl mx-auto ${className}`} data-testid={testId}>
      <div className="rounded-3xl bg-forest text-cream p-8 sm:p-12 flex flex-col md:flex-row md:items-center justify-between gap-8">
        <div className="space-y-3 max-w-2xl">
          <h2 className="font-serif text-4xl sm:text-5xl">{t("bilet.cta.title")}</h2>
          <p className="text-cream/85">{t("bilet.cta.text")}</p>
          <p className="text-sm text-cream/75">{t("bilet.parkNote")}</p>
          {!live && <Pending testId={`${testId}-pending`} />}
        </div>
        <Link to={path("bilet")} className="shrink-0 inline-flex items-center justify-center gap-2 min-h-[56px] px-8 rounded-full bg-honey text-forest-dark font-semibold hover:brightness-105 transition-[filter]" data-testid={`${testId}-button`}>
          <Ticket className="h-5 w-5" aria-hidden="true" /> {t("bilet.cta.button")}
        </Link>
      </div>
    </section>
  );
}
